import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EventWorldService } from '../events/event-world.service';
import { EventWorldModel } from '../events/EventWorldModel';
import { ImagesModel } from '../events/ImagesModel';
import { EvaluationsModel } from '../EvaluationsModel';
import { EvaluationEventService } from '../evaluation-event.service';
import { ReportModel } from '../../Reports/ReportModel';
import { ReportService } from '../../Reports/report.service';
import { ToastrService } from 'ngx-toastr';
@Component({
    // moduleId: module.id,
    selector: 'event-details-in-country',
    templateUrl: 'event-details-in-country.component.html',
    styleUrls: ['event-details-in-country.component.scss']
})
export class EventDetailsInCountryComponent implements OnInit {
    Menuoption = 'center';
    Settingicon = true
    navClass = 'nav-light';

      projectDetails : any;
      projectGallaryConfig  = {"slidesToShow": 1,"fade": true, "slidesToScroll": 1,"arrows": false,"dots": false,"autoplay": true, "autoplaySpeed": 2000};
    declare lang: any;
  
      constructor( 
          public router: Router,
          private formBuilder : FormBuilder,
          private modelService :EventWorldService,
          private route: ActivatedRoute,
          private ReportService:ReportService,
          private toster:ToastrService,
          private EvaluationService:EvaluationEventService,
          ) {      this.id = +route.snapshot.paramMap.get("id");
         }
         id=0;
         ngOnInit() {
          // this.lang = localStorage.getItem('theme_lang');
     
          if(this.id > 0)
          {
            debugger;
            this.modelService.getById(this.id).subscribe(data=>{
              this.modelObject=data;
              this.files=this.modelObject.eventImagesList;
              this.EvaluationService.GetAllByEventId(this.id).subscribe(data=>{
                this.EvaluationList=data;
              })
              console.log("modelObject",this.rows)
  
            })
            
          }
          else{
          }
          
  
      }
      selectedIndex: number = 0;
      @Input()
      data:any;
      modelObject: EventWorldModel = new EventWorldModel();
      rows :EventWorldModel[]= [];
  
      mainForm: FormGroup = new FormGroup({
          id: new FormControl(),
          images: new FormControl(),
          titleAr: new FormControl(),
          titleEn: new FormControl(),
          titleFr: new FormControl(),
          descriptionAr: new FormControl(),
          descriptionEn: new FormControl(),
          descriptionFr: new FormControl(),
          latitude: new FormControl(),
          longitude: new FormControl(),
          countryId: new FormControl(),
          cityId: new FormControl(),
          userId: new FormControl(),
          date: new FormControl(),
      });
     
        files:ImagesModel[]=[];
        EvaluationList:EvaluationsModel[]=[];
        public myComment: string ='';
        public myStars: number =0;
        public myTime: Date =new Date();
        public myDate: Date =new Date();
        editEnabled = true;
        goBack(){
          this.router.navigate(['/blimp/events']);
        }
       selectedImages:ImagesModel={};
        setImage(EventId){
          debugger;
          var i = this.files.findIndex(x=>x.eventWorldId == this.id);
          if(i>-1){
            this.selectedImages = this.files[i];
          }
          else{
            this.selectedImages.imageURL=''
          }
          
        }
        EventDetails(id){
            debugger;
          this.router.navigate(['/country-events/',id]);
          
        }

        EvaluationsObject: EvaluationsModel = new EvaluationsModel();

        SaveEvaluation() {
          debugger;
          this.EvaluationsObject = new EvaluationsModel();
          this.EvaluationsObject.id = 0;
          this.EvaluationsObject.comment = this.myComment;
          this.EvaluationsObject.eventId = this.id;
          this.EvaluationsObject.numberOfStars = this.myStars;
          this.EvaluationsObject.date = this.myDate;
          this.EvaluationsObject.time = this.myTime;
          this.EvaluationsObject.userId = 0;
          this.EvaluationsObject.isHide = false;
          console.log(this.modelObject);
          console.log(this.modelObject);
          this.EvaluationService.insert(this.EvaluationsObject).subscribe((data) => {
            this.myComment='';
            this.myStars=0;
            this.ngOnInit();
            // this.router.navigate(["app/HR/List-Salaries-Manager"]);
          });
        }
        
      ReportObject:ReportModel=new ReportModel();
      ReportForm:FormGroup=new FormGroup({
      id: new FormControl(),
      message: new FormControl(),
      commentId: new FormControl(),
      userId: new FormControl(),
      });
      public message: string ='';
      commetId=0;
      setCommentId(commetId){
        this.commetId =commetId;
  
      }
  @ViewChild('closebutton') closebutton;
        SendReport() {
          debugger;
          this.ReportObject = new ReportModel();
          this.ReportObject.id = 0;
          this.ReportObject.message = this.message;
          this.ReportObject.commentId = this.commetId;
          this.ReportObject.userId = 0;
          this.ReportObject.Type = 'events';
          console.log(this.modelObject);
          this.ReportService.insert(this.ReportObject).subscribe((data) => {
          this.message='';
          this.commetId=0;
          this.closebutton.nativeElement.click();
            this.toster.success("Success")
            // this.ngOnInit();
          });
        }



}
